import React, { createContext, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import jwt_decode from 'jwt-decode';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true); // Add loading state
  const navigate = useNavigate();

  useEffect(() => {
            const token = localStorage.getItem('token');
        if (token) {
          try {
            const decodedUser = jwt_decode(token);
            setUser(decodedUser);
            setIsAuthenticated(true);
            console.log('AuthContext useEffect - decodedUser:', decodedUser); // ADDED LOG
          } catch (error) {
            console.error('Failed to decode token:', error);
            localStorage.removeItem('token');
          }
        }    setLoading(false);
  }, []);

  const login = async (username, password, isAdminLogin = false) => {
    // --- START: FAKE ADMIN LOGIN CONDITION (FOR DEVELOPMENT ONLY) ---
    const FAKE_ADMIN_USERNAME = 'devadmin';
    const FAKE_ADMIN_PASSWORD = 'devpass';

    if (isAdminLogin && username === FAKE_ADMIN_USERNAME && password === FAKE_ADMIN_PASSWORD) {
      const fakeToken = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6OTk5LCJyb2xlIjoiYWRtaW4iLCJpYXQiOjE1MTYyMzkwMjJ9.fake_admin_token'; // A dummy token
      localStorage.setItem('token', fakeToken);
      const decodedUser = { id: 999, role: 'admin' };
      setUser(decodedUser);
      setIsAuthenticated(true);
      console.log('AuthContext login - FAKE ADMIN LOGIN SUCCESS');
      return { success: true };
    }
    // --- END: FAKE ADMIN LOGIN CONDITION ---

    try {
      const endpoint = isAdminLogin ? `${process.env.REACT_APP_API_URL}/api/auth/admin-login` : `${process.env.REACT_APP_API_URL}/api/auth/login`;
      const response = await fetch(endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ username, password }),
      });

      const data = await response.json();

      if (response.ok) {
        localStorage.setItem('token', data.token);
        const decodedUser = jwt_decode(data.token);
        setUser(decodedUser);
        setIsAuthenticated(true);
        console.log('AuthContext login - decodedUser:', decodedUser); // ADDED LOG
        return { success: true };
      } else {
        return { success: false, message: data.message || 'Login failed' };
      }
    } catch (error) {
      console.error('Login error:', error);
      return { success: false, message: 'Server error during login' };
    }
  };

  const logout = () => {
    localStorage.removeItem('token');
    setIsAuthenticated(false);
    setUser(null);
    navigate('/admin/login'); // Redirect to admin login after logout
  };

  const isAdmin = user && user.role === 'admin';
  console.log('AuthContext - isAuthenticated:', isAuthenticated, 'isAdmin:', isAdmin, 'user:', user); // ADDED LOG

  return (
    <AuthContext.Provider value={{ isAuthenticated, user, login, logout, isAdmin, loading }}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
